import { combineReducers } from "redux";
import screening from "./Screening/";
import events from "./Events";

const rootReducer = combineReducers({
  screening: screening,
  events: events,
});

export default rootReducer;
